import React from 'react';

import PropTypes from 'prop-types';

import { Body, ColorSwatch } from '@iris/react-components';

import { getColorVariant } from '@/containers/vdp/VehicleFeaturesContainer/VehicleFeatureHighlights/utils/getColorSwatchData';

/**
 * Component to render color swatches for exterior and interior colors
 * @param {Object} props
 * @param {string} props.type - 'exterior' or 'interior'
 * @param {string} props.colorValue - The direct color value
 * @param {string} props.colorDescription - The color description
 */
function ColorDisplay({ type, colorValue, colorDescription }) {
    const colorVariant = getColorVariant(colorValue, colorDescription);

    if (!colorVariant) {
        return null;
    }

    return (
        <div
            key={`${type}-color`}
            className="iris:flex iris:items-center iris:gap-2"
        >
            <ColorSwatch
                className="iris:h-5 iris:w-5" // class defining height and width is currently required for this component to show correctly
                data-cmp={`${type}-color-swatch`}
                variant={colorVariant}
            />
            <Body
                as="span"
                className="no-wrap"
            >
                {colorDescription || `${(type?.charAt(0).toUpperCase() ?? '') + (type?.slice(1) ?? '')} Color`}
            </Body>
        </div>
    );
}

ColorDisplay.propTypes = {
    type: PropTypes.oneOf(['exterior', 'interior']).isRequired,
    colorValue: PropTypes.string,
    colorDescription: PropTypes.string,
};

export default ColorDisplay;
